import styles from "./ProgressBar.module.css";

function ProgressBar({
	title = false,
	isTitleImg = false,
	value,
	maxValue,
	valueType = "",
	valueDecimal = 0,
	showMaxValue = true,
	progressLabelColor = "#10284E",
	progressColor = "#10284E",
}) {
	const progress = (value / maxValue) * 100;
	return (
		<div className={styles.container}>
			{title && !isTitleImg && (
				<div className={styles.title}>{title}</div>
			)}
			{isTitleImg && title}
			<div className={styles.progressContainer}>
				<div className={styles.bar}>
					<div
						className={styles.progress}
						style={{
							width: `${progress}%`,
							backgroundColor: progressColor,
						}}
					></div>
					{value < maxValue && showMaxValue && (
						<div
							className={styles.progressLabel}
							style={{
								marginLeft: `${progress}%`,
								color: progressLabelColor,
							}}
						>
							{value.toFixed(valueDecimal)}
							{valueType}
						</div>
					)}
				</div>
				{showMaxValue && (
					<div className={styles.label}>
						{maxValue.toFixed(valueDecimal)}
						{valueType}
					</div>
				)}
				{!showMaxValue && (
					<div className={styles.label}>
						{value.toFixed(valueDecimal)}
						{valueType}
					</div>
				)}
			</div>
		</div>
	);
}

export default ProgressBar;
